export default "__VITE_ASSET__DocfomHZ__"